import { Routes } from '@angular/router';

export const appRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('@jump-tech-frontend/portal').then(m => m.MainComponent),
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'home' },
      {
        path: 'home',
        loadComponent: () => import('@jump-tech-frontend/portal').then(m => m.HomeComponent)
      },
      {
        path: 'messages',
        loadComponent: () => import('@jump-tech-frontend/portal').then(m => m.MessagesComponent)
      },
      {
        path: 'survey',
        loadComponent: () => import('@jump-tech-frontend/portal-relay-host').then(m => m.SurveyComponent)
      },
      {
        path: 'additional-info',
        loadComponent: () => import('@jump-tech-frontend/portal').then(m => m.AdditionalInfoComponent)
      },
      {
        path: 'additional-info/:itemKey',
        loadComponent: () => import('@jump-tech-frontend/portal').then(m => m.ItemComponent)
      }
    ]
  }
];
